'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CLEAR_REFRESH_TOKEN_PROMISE = exports.CLEAR_REFRESH_TOKEN_PROMISE = 'CLEAR_REFRESH_TOKEN_PROMISE';
var SAVE_REFRESH_TOKEN_PROMISE = exports.SAVE_REFRESH_TOKEN_PROMISE = 'SAVE_REFRESH_TOKEN_PROMISE';
var SET_ACCESS_TOKEN = exports.SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';

var clearRefreshTokenPromise = exports.clearRefreshTokenPromise = function clearRefreshTokenPromise() {
  return {
    type: CLEAR_REFRESH_TOKEN_PROMISE
  };
};

var saveRefreshTokenPromise = exports.saveRefreshTokenPromise = function saveRefreshTokenPromise(promise) {
  return {
    type: SAVE_REFRESH_TOKEN_PROMISE,
    promise: promise
  };
};

var setAccessToken = exports.setAccessToken = function setAccessToken(_ref) {
  var access_token = _ref.access_token,
      expires_in = _ref.expires_in;
  return {
    type: SET_ACCESS_TOKEN,
    access_token: access_token,
    expires_in: expires_in
  };
};